export default __webpack_public_path__ + "static/media/IconUserCircle.53d75bf6.svg";